import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class McqCommentService extends BaseService {
  constructor() {
    super(constants.ADD_MCQ_COMMENT, 'McqCommentService');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);

    // Remove aetquiz, aettopic, topics, feedbacks, and rawResponse from payload before sending to API
    const { aetquiz, aettopic, topics, feedbacks, rawResponse, ...basePayload } = payload;

    // Filter out undefined and null values from payload
    const apiPayload = Object.keys(basePayload).reduce((acc, key) => {
      if (basePayload[key] !== undefined && basePayload[key] !== null) {
        acc[key] = basePayload[key];
      }
      return acc;
    }, {});

    if (payload?.aetquiz) {
      return this.getClient('aiadminv2').post(`/cm/quiz-aet/comment`, apiPayload, { headers });
    }
    if (payload?.aettopic) {
      // Ensure productModel is included for AET Topic comments
      if (!apiPayload.productModel) {
        apiPayload.productModel = 'ETEXT_EPUB_BRONTE'; // Default productModel
      }
      return this.getClient('aiadminv2').post(`/cm/topic-aet/comment`, apiPayload, { headers });
    }
    return this.getClient('aiadmin').post(`/chatutility/quizmcq/comment`, apiPayload, { headers });
  }

  handleResponse(response) {
    const { data, status } = response;
    const isAetQuiz = data?.data?.aetquiz;
    const isAetTopic = data?.data?.aettopic;

    let storeToUse = 'chatgptTocUtility';
    if (isAetQuiz) {
      storeToUse = 'aetQuizUtility';
    } else if (isAetTopic) {
      storeToUse = 'aetTopicUtility';
    }

    if (status === 200 && data && !isAetQuiz && !isAetTopic) {
      const notification = {
        open: true,
        type: 'success',
        message: 'Comment added successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);

      Framework.getStoreRegistry().getStore(storeToUse).setMcqCommentSuccess();
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Failed to add comment'
      };
      Framework.getStoreRegistry().getStore(storeToUse).setMcqCommentSuccess();
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      } else if (status === 400 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message || 'Bad Request',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
